export const clientInfoAdapter = (data) => {
	return [
		{
			email: data?.email || '-',
			name: data?.first_name + ' ' + data?.last_name || '-',
			phone: data?.phone || '-',
			rut: data?.rut || '-',
		},
	];
};
